import React from 'react';

import { Text } from '@reckon-web/text';
import { Tooltip } from '@reckon-web/tooltip';

const MAGIC_NUMBER = 33;

export const EmailOrUsernameMasking = ({ children }: { children: string }) => {
  const hasOverflow = children.length > MAGIC_NUMBER;
  const maybeEllipsis = hasOverflow ? '...' : '';
  const textElement = (
    <Text size="small">
      {children.slice(0, MAGIC_NUMBER)}
      {maybeEllipsis}
    </Text>
  );

  if (hasOverflow) {
    return <Tooltip content={children}>{textElement}</Tooltip>;
  }

  return textElement;
};
